/** Backend subtype names mapped to the SVG category shown in the strip. */
export const TYPE_FILTER_STRIP_MAPPING: Readonly<Record<string, string>> = {
  'nose pins': 'Nose Accessory',
  'nose screws': 'Nose Accessory',
  'nose rings': 'Nose Accessory',
  'adjustable bracelets': 'Bracelets',
  'kids bracelets': 'Bracelets',
  'kids bangles': 'Bangles',
  'preset solitaire bangles': 'Bangles',
  'kids rings': 'Rings',
  'adjustable rings': 'Rings',
  'thumb rings': 'Rings',
  'midi rings': 'Rings',
  'mangalsutra chains': 'Mangalsutra',
  'preset solitaire cufflinks': 'Cufflinks',
};
